import { TrackingEvent } from '@x/common/tracking/event-models/event';

export abstract class TrackingProvider {
  abstract init(): Promise<boolean>;
  abstract sendEvent<T extends object>(event: TrackingEvent<T>): void;
}
